/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\FindUser\FindUserAdmin.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Thursday December 14th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday December 14th 2023 2:09:29 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { useEffect, useState } from "react";
import FindUser from "./FindUser";
import translator from "MultiLanguage/TranslationWrapper";
import { FormControlLabel, Switch } from "@mui/material";

type FindUserAdminProps = {
    setUserID: Function,
    setWithAdmin: Function,
    withAdmin: boolean,
    adminOpt: boolean,
    setSearchTerm: Function,
    searchTerm: string | undefined,
}

const FindUserAdmin = (props: FindUserAdminProps) => {
    const [check, setCheck] = useState<boolean>(props.withAdmin);

    useEffect(() => {
        if (props.withAdmin !== check)
            props.setWithAdmin(check);
    }, [check]);

    useEffect(() => {
        if (!props.adminOpt && props.adminOpt !== check) {
            setCheck(false);
        }
    }, [props.adminOpt]);

    return (
        <div className="d-flex gap-3">
            {
                props.adminOpt ?
                <FormControlLabel control={<Switch checked={check} onClick={() => setCheck(!check)}/>} label={translator.decode("dynamic.inclAdmin")} />
                : null
            }
            <FindUser setSearchTerm={props.setSearchTerm} searchTerm={props.searchTerm} setUserID={props.setUserID} queryParams={!props.adminOpt && !check ? {scope: "client"} : {}}/>
        </div>
    )
}

export default FindUserAdmin;
